import { Component, OnInit } from "@angular/core";
import { HttpService } from "../../service/HTTPService/HttpService";

@Component({
  selector: "app-alarmlegends",
  templateUrl: "./alarmlegends.component.html",
  styleUrls: ["./alarmlegends.component.css"],
})
export class AlarmlegendsComponent implements OnInit {
  alarmlegends: any;
  alarmlegenddetails;
  alarmHeaders;
  alramTableData;
  constructor(private http: HttpService) {
    this.http.get("assets/JSON/alarmLegends.json").subscribe((res) => {
      const getResp: string = JSON.stringify(res);
      const assetInfo = JSON.parse(getResp);
      this.alarmHeaders = assetInfo.headers;
      this.alarmlegenddetails = assetInfo.tableData;
    });

  }

  ngOnInit(): void {
  
  }
}
